import type { ListingType } from 'app/types/listing';

export enum Strategies {
  UsePredictions = 'predictions',
  UseUserItemPredictions = 'user-item',
  UsePastInteractions = 'past-interactions',
  UseTestRecommendations = 'test-recommendations',
  UseMixedRecommendations = 'mixed-recommendations',
  UseOneToManySimilarListings = 'one-to-many-similar-listings',
  UseMatchNeedsWithOffers = 'match-needs-with-offers',
  YourFavourites = 'your-favourites',
  UrgentNeeds = 'urgent-needs',
  RecentOffers = 'recent-offers',
  MostPopular = 'most-popular',
  RecentLoans = 'recent-loans',
  YourInterest = 'your-interest',
  ByCategory = 'by-category',
  NeighbourOffers = 'neighbour-offers',
  NeighbourRequests = 'neighbour-requests',
  NearestSharingPlace = 'nearest-sharing-place',
}

const API_STRATEGIES = new Set<Strategies>([
  Strategies.YourFavourites,
  Strategies.UrgentNeeds,
  Strategies.RecentOffers,
  Strategies.MostPopular,
  Strategies.RecentLoans,
  Strategies.YourInterest,
  Strategies.ByCategory,
  Strategies.NeighbourOffers,
  Strategies.NeighbourRequests,
  Strategies.NearestSharingPlace,
]);

export const isApiStrategy = (strategy: Strategies): boolean => API_STRATEGIES.has(strategy);

export function getRecommendationTitleKey({
  strategy,
  recommendationType,
}: {
  strategy: Strategies;
  recommendationType?: ListingType;
}) {
  const titleKey = `${strategy}.title`;
  return strategy === Strategies.UseOneToManySimilarListings && recommendationType
    ? `${titleKey}.${recommendationType}`
    : titleKey;
}
